import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import * as styles from './MarketModal.module.css';

interface MarketModalProps {
    onClose: () => void;
    redirectOnClose?: boolean;
}

export const MarketModal: React.FC<MarketModalProps> = ({ onClose, redirectOnClose = false }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
            if (redirectOnClose) {
                // Scroll to #fruit-section
                const element = document.getElementById('fruit-section');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                } else if (window.location.pathname !== '/aw') {
                    window.location.href = '/aw#fruit-section';
                }
            }
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose, redirectOnClose]);

    // Portal to body to ensure it overlays everything
    if (typeof document === 'undefined') return null;

    return createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                {/* 
                   User request: title 80%, text 65%. 
                   I am using inline styles to strictly adhere to the user's specific "80%" request 
                   over the CSS class to ensure they see exactly what they asked for, 
                   relative to the container's base size (16px default).
                */}
                <h2 className={styles.title} style={{ fontSize: '150%' }}>Estimado usuario</h2>
                <p className={styles.text} style={{ fontSize: '90%' }}>
                    El NikoVen Market se encuentra en desarrollo por los momentos.
                    Intentaremos habilitarlo lo más rápido posible.
                </p>
                <p className={styles.text} style={{ fontSize: '90%' }}>
                    Contáctese con algún agente que lo atenderá de manera personalizada lo más pronto posible.
                </p>
            </div>
        </div>,
        document.body
    );
};
